export default __webpack_public_path__ + "static/international-business-728f32bae74c83b17d94ef2c8a9835d7.jpg";